import { Chip, Divider, Grid, Typography } from '@material-ui/core';
import { Control, lightGreen, withTooltip } from '../../core';
import { EmCategoryApi } from './em-category-api';
import InfoOutlined from '@material-ui/icons/InfoOutlined';

type EmCategoryColumnProps = EmCategoryApi;

function ColumnOptions(c: Control) {
  let { onChange, multipleSelect } = c.field;

  const options = c.options((s) => s.value);
  const setValue = c.value((s) => s.setValue);

  const onClick = (i: number) => {
    options[i].selected = !options[i].selected;

    if (!multipleSelect) {
      options.forEach((o, j) => {
        if (j !== i) {
          o.selected = false;
        }
      });
      setValue(options[i].selected ? options[i].value : null);
    }
    c.options.setState({ value: c.options.getState().value.slice() });
    if (onChange) {
      onChange(options[i]);
    }
  };
  const active = c.disabled((s) => s.value);
  const id = c.id || c.field.id || 'id';

  c.options((s) => s.value);

  return (
    <>
      {options.map((o, i) => (
        <Chip
          disabled={active}
          clickable
          key={i}
          id={id + i}
          size="small"
          variant="outlined"
          style={{
            margin: 4,
            backgroundColor: o.selected ? lightGreen : undefined,
          }}
          label={o.label || o.value}
          onClick={() => onClick(i)}
        />
      ))}
    </>
  );
}

function ColumnHeader({ title, description }) {
  return (
    <Grid
      item
      container
      spacing={1}
      style={{ flexWrap: 'nowrap', paddingLeft: 6 }}
    >
      <Grid item>
        <Typography variant="overline">{title}</Typography>
      </Grid>
      <Grid item style={{ marginTop: 4 }}>
        {withTooltip(
          description,
          <InfoOutlined style={{ opacity: 0.5 }} fontSize="small" />
        )}
      </Grid>
    </Grid>
  );
}
const columnStyle = { minWidth: 80 };
const dividerStyle = { marginRight: 12, width: 1 };
const chipStyle = { padding: 0, marginTop: -2 };

export function EmCategoryColumns({ form }: EmCategoryColumnProps) {
  const { opt, data, risk } = form.controls;

  return (
    <Grid
      item
      container
      direction="row"
      style={{ flexWrap: 'nowrap', marginTop: -10, marginLeft: 48 }}
    >
      <Grid item container direction="column" style={columnStyle}>
        <ColumnHeader
          title="COPA"
          description="Number and Complexity of Problems Addressed"
        />
        <Grid item style={chipStyle}>
          <ColumnOptions {...opt} />
        </Grid>
      </Grid>
      <Divider flexItem orientation="vertical" style={dividerStyle} />

      <Grid item container direction="column" style={columnStyle}>
        <ColumnHeader
          title="Data"
          description="Amount and/or Complexity of Data to be Reviewed and Analyzed"
        />
        <Grid item style={chipStyle}>
          <ColumnOptions {...data} />
        </Grid>
      </Grid>

      <Divider flexItem orientation="vertical" style={dividerStyle} />

      <Grid item container direction="column" style={columnStyle}>
        <ColumnHeader
          title="Risk"
          description="Risk of Complications and/or Morbidity or Mortality of Patient Management"
        />

        <Grid item style={chipStyle}>
          <ColumnOptions {...risk} />
        </Grid>
      </Grid>
    </Grid>
  );
}
